app
    .controller('CoachSocialFormCtrl', function CoachImageFormCtrl($http) {

        this.platforms = [
            {icon: 'insta', name: 'instagram'},
            {icon: 'facebook', name: 'facebook'},
            {icon: 'youtube', name: 'youtube'},
            {icon: 'linkedin', name: 'linkedin'},
            {icon: 'twitter', name: 'twitter'}
        ];

        this.$onInit = () => {
            this.coach = this.resolve.coach;
        };

        this.save = () => {
            $http.post(`/coach/social/${this.resolve.coach.id}`, this.coach.socialProfile).then(() => {
                this.close();
            });
        };

        this.cancel = () => {
            this.dismiss();
        };

        this.valueChanged = (platformName) => {
            if (this.coach.socialProfile[platformName]) {
                this.coach.socialProfile[platformName].enabled = true;
            } else {
                this.coach.socialProfile[platformName].enabled = null;
            }
        };
    })
    .component('coachSocialForm', {
        template: `
        <form ng-submit="$ctrl.save()">
            <div class="modal-header">
                <h3 class="modal-title" id="modal-title">{{ 'modal.socialForm.title' | translate}}</h3>
                <button class="btn btn-close" ng-click="$ctrl.cancel()">
                    <chat-icon type="cross" width="15" />
                </button>
            </div>
            <div class="modal-body social" id="modal-body">
                <div>
                    <div class="form-group" ng-repeat="platform in $ctrl.platforms" style="display: flex; justify-content: center; align-items: center;">
                        <chat-icon type="{{platform.icon}}" width="32" class="mr-3"/>
                        <input type="checkbox" class="mr-3" ng-model="$ctrl.coach.socialProfile[platform.name].enabled">
                        <input type="url" class="form-control" domain-validate="{{platform.name}}" ng-change="$ctrl.valueChanged(platform.name)" ng-model="$ctrl.coach.socialProfile[platform.name].url">
                    </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-save" type="submit">{{ 'modal.socialForm.button.save' | translate}}</button>
            </div>
        </form>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'CoachSocialFormCtrl'
    });


app.directive('domainValidate', function domainValidate() {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function (element, scope, attributes, ngModel) {
            ngModel.$validators.domainValidate = function (modelValue) {
                const s = `^(http(s)?(:\/\/))?(www\.)?${attributes.domainValidate}\.com(\/.*)?$`;
                if (new RegExp(s).test(modelValue)) {
                    return true;
                } else {
                    return false;
                }
            };
        }
    };
});
